import config from './config'

const PREFIX = `uprightlabs`
const PREFIX_USER = `uprightlabs:userId:${config.user.id}`

export function getKey(key: string, userScoped = false): string {
  return `${userScoped ? PREFIX_USER : PREFIX}:${key}`
}

// Consider using useRememberedState instead of this method directly.
export function getFromStorage(key: string, userScoped = false): any {
  const get = localStorage.getItem(getKey(key, userScoped))
  if (get) {
    return JSON.parse(get)
  }
  return null
}

export function setInStorage(key: string, item: any, userScoped = false): boolean {
  try {
    const value = JSON.stringify(item)
    localStorage.setItem(getKey(key, userScoped), value)
    return true
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return false
  }
}

export default {
  getKey,
  getFromStorage,
  setInStorage
}
